export default __webpack_public_path__ + "assets/images/17a8ab90b74bf4253abf2a5ab7081327.jpg";